import { Injectable, inject } from '@angular/core';
import { ProjectResponseGetById } from '@nx-customer-apps/api-planning-projects';
import { ProjectType, RemoteConfigParameter } from '@nx-customer-apps/shared/enums';
import { RemoteConfigService } from './remote-config.service';
import { AuthService } from './auth.service';
import { VariantsService } from '../projects/project-details/services';
import { ProjectsService } from './projects.service';

@Injectable({
    providedIn: 'root'
})
export class PitchDeckService {
    private projectsService = inject(ProjectsService);
    private remoteConfigService = inject(RemoteConfigService);
    private authService = inject(AuthService);

    /**
     * @param project currently selected project.
     * @param variantId Required. Pitch deck availability is determined by scope of certain variant.
     * @returns whether pitch deck report is available for export for certain variant.
     */
    public isPitchDeckAvailable(project: ProjectResponseGetById, variantId: string | null | undefined): boolean {
        if (!variantId) {
            return false;
        }

        const targetVariant = project.variants.find(v => v.id === variantId);
        const locale = `${project.languageCode}-${project.countryCode}`;
        const isAddressCountryCodeSameAsSalesOrgCountryCode = project.countryCode === project.address?.countryCode;
        const supportedLocales = this.remoteConfigService.getSplitedConfigParameter(RemoteConfigParameter.PdfConfiguratorPitchDeckByLocale);
        return (
            this.projectsService.isRenovation(project.projectType as ProjectType) &&
            supportedLocales.includes(locale) &&
            isAddressCountryCodeSameAsSalesOrgCountryCode &&
            (VariantsService.isUserVariant(targetVariant) ||
                (this.remoteConfigService.getConfigParameter(RemoteConfigParameter.IsPitchDeckAvailableForAllVariants) as boolean)) &&
            (this.authService.isEmployee() || this.authService.isSystemProfi())
        );
    }
}
